import { BaseApi } from './base.api.js';

export class RiskAnalysisApi extends BaseApi {
    constructor(client) {
        super(client, '/risk-analysis');
    }

}
